export default "__VITE_ASSET__BukO36p2__"